import {
  compose,
} from 'recompose';

import RequestView from './RequestView';

export default compose()(RequestView);
